import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SuperAdminCurrentMapLocationComponent } from './maps/super-admin-current-map-location/super-admin-current-map-location.component';
import { GalleriaModule } from 'primeng/galleria';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BookingOffersListModalComponent } from './booking-offers-list-modal/booking-offers-list-modal.component';
import { PaymentSucessComponent } from './payment-success/payment-success.component';
import { RecommendationMessageComponent } from './recommendation-message/recommendation-message.component';
import { CancelBookingComponent } from './cancel-booking/cancel-booking.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { PaymentPaidModalComponent } from './payment-paid-modal/payment-paid-modal.component';
import { ToastModule } from 'primeng/toast';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from '@shared/shared.module';
@NgModule({
  declarations: [
    SuperAdminCurrentMapLocationComponent,
    TermsConditionComponent,
    BookingOffersListModalComponent,
    PaymentSucessComponent,
    RecommendationMessageComponent,
    CancelBookingComponent,
    PaymentPaidModalComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    GalleriaModule,
    AutoCompleteModule,
    ConfirmPopupModule,
    FormsModule, 
    ReactiveFormsModule,
    ConfirmDialogModule,
    ToastModule,
    InlineSVGModule,
    SharedModule
  ],
  providers: [
    ConfirmationService
  ],
  exports: [
    SuperAdminCurrentMapLocationComponent,
    TermsConditionComponent,
    BookingOffersListModalComponent,
    PaymentSucessComponent,
    RecommendationMessageComponent,
    FormsModule, 
    ButtonModule,
    ReactiveFormsModule,
    PaymentPaidModalComponent
  ]
})

export class BookingFlowModule { }
